import React, { Component } from 'react';
import Inbox from './Inbox.js';

export default class InboxAll extends Component {
  render() {
    return (
      <Inbox type='all'/>
    );
  }
}
